import { Card } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const PageContentContainer = ({ children }: Props) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        height: '100%',
      }}>
      {children}
    </Card>
  );
};

export default PageContentContainer;
